import { render, staticRenderFns } from "./ChatBoxMessageList.vue?vue&type=template&id=24525c83&scoped=true&"
import script from "./ChatBoxMessageList.vue?vue&type=script&lang=js&"
export * from "./ChatBoxMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxMessageList.vue?vue&type=style&index=0&id=24525c83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24525c83",
  null
  
)

export default component.exports